var newUrl = "";
jQuery(document).on("filterAction", function () {
  theFunctionNeedToLoadAfterFiltering();
});

function filterUpdated(event) {
  let form = document.getElementById("filter_form");
  const formData = new FormData(form);
  const queryParams = [];

  // Iterate over form data entries
  for (const [key, value] of formData.entries()) {
    // Only add non-empty parameters
    if (value !== "") {
      queryParams.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      );
    }
  }

  // Get the current sort-by value from the URL
  const currentParams = new URLSearchParams(window.location.search);
  const currentSortBy = currentParams.get("sort_by");

  if (currentSortBy) {
    queryParams.push(`sort_by=${encodeURIComponent(currentSortBy)}`);
    updateLastSeparator();
  }

  // Construct query string
  const queryString = queryParams.join("&");
  let url = `/collections/${plpHandle}?` + queryString;
  newUrl = url;

  // callApi(url);
  var $filterLabel = $(event?.target); // Wrap event.target in a jQuery object
  var inputValue = $filterLabel?.val();
  var dataFilter = $filterLabel?.data("filter-label");

  if ($filterLabel.attr("checked")) {
    $(
      `input[value='${inputValue}'][data-filter-label='${dataFilter}']`
    ).removeAttr("checked");
  } else {
    $(`input[value='${inputValue}'][data-filter-label='${dataFilter}']`).attr(
      "checked",
      "checked"
    );
    // console.log("event Else condition", $filterLabel.val());
  }

  if (queryString != "") {
    $(
      ".filter-apply-button.desk-apply, .filter-apply-button.mob-apply"
    ).addClass("bg-black");
    $(".mob-apply_container").removeClass("hide");
  } else if (queryString == "") {
    $(
      ".filter-apply-button.desk-apply, .filter-apply-button.mob-apply"
    ).removeClass("bg-black");
    $(".mob-apply_container").addClass("hide");
  }
}

function theFunctionNeedToLoadAfterFiltering() {
  $(".filter-apply-button").click(function () {
    callApi(newUrl);
  });

  $(".filter-clear-button, .filter-wrapper, .clear-filters").click(function (
    event
  ) {
    event.stopPropagation();
    clearAllFilter(event);
    if ($(event.currentTarget).hasClass("filter-clear-button")) {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "1004101204"]);
    }
    if ($(event.currentTarget).hasClass("filter-wrapper")) {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "1004101205"]);
    }
  });

  const params = new URLSearchParams(window.location.search);
  let filterCount = 0;
  let hasPriceFilter = false;

  params.forEach((value, key) => {
    if (key.startsWith("filter.")) {
      if (key === "filter.v.price.gte" || key === "filter.v.price.lte") {
        hasPriceFilter = true;
      } else {
        filterCount++;
      }
    }
  });

  if (hasPriceFilter) {
    filterCount++;
  }
  // return filterCount;

  if (filterCount > 0) {
    $(
      ".filter-clear-button, .filter-wrapper, .mob-apply_container"
    ).removeClass("hide");
    $(".filter-apply-button.mob-apply").removeClass("bg-black");
    $(".filter-count").text(filterCount);
  }

  // Close all other open items in mobile
  $(".new-template-counter-mobile details.filter-group[open]").removeAttr(
    "open"
  );
  $(".new-template-counter-mobile details.filter-group").click(function () {
    $(".new-template-counter-mobile details.filter-group[open]")
      .not(this)
      .removeAttr("open");
  });
}
// Example usage
theFunctionNeedToLoadAfterFiltering();

function rangeUpdated(event) {
  const fromSliderInp = document.querySelector("#fromSlider");
  const toSliderInp = document.querySelector("#toSlider");
  const fromInputVal = document.querySelector("#fromInput");
  const toInputVal = document.querySelector("#toInput");

  let minValue;
  let maxValue;

  if (event.target.id == "fromSlider") {
    minValue = event.target.value;
  }
  if (event.target.id == "toSlider") {
    maxValue = event.target.value;
  }
  if (event.target.id == "fromInput") {
    minValue = event.target.value;
  }
  if (event.target.id == "toInput") {
    maxValue = event.target.value;
  }

  // Update input field values
  fromInputVal.value = minValue ? minValue : fromSliderInp.value;
  toInputVal.value = maxValue ? maxValue : toSliderInp.value;

  filterUpdated();
}

function clearPlaceholder(event) {
  const inputField = event.target;
  inputField.placeholder = ""; // Set placeholder to an empty string
}
function clearAllFilter(event) {
  event.preventDefault();
  let url = `/collections/${plpHandle}?`;
  callApi(url);
}

function filterRemoved(event) {
  event.preventDefault();
  const urlToRemove = event.currentTarget.getAttribute("href");
  callApi(urlToRemove);
}
function updateLastSeparator() {
  var separators = document.querySelectorAll(
    ".price_sliders_control .separator"
  );
  var lastSeparator = separators[separators.length - 1]; // Gets the last separator regardless of count

  var labelSeparators = document.querySelectorAll(
    ".price_sliders_control .separator-label"
  );
  var lastLabel = labelSeparators[labelSeparators.length - 1]; // Gets the last label

  if (window.innerWidth >= 768 && window.innerWidth <= 819) {
    // Specifically targeting iPad viewport sizes
    if (lastSeparator) {
      lastSeparator.style.left = "calc(100% + 22px)";
    }
    if (lastLabel) {
      lastLabel.style.left = "calc(100% + 23px)";
    }
  } else if (window.innerWidth >= 819 && window.innerWidth <= 1024) {
    if (lastSeparator) {
      lastSeparator.style.left = "calc(100% + 22px)";
    }
    if (lastLabel) {
      lastLabel.style.left = "calc(100% + 23px)";
    }
  }
  if (window.innerWidth > 768) {
    var pdItemHeight = $(".product-item .left").height();
    $(".merchandise-grid .promo-banner").css("height", pdItemHeight);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  updateLastSeparator();
  window.addEventListener("resize", updateLastSeparator);
  if (window.innerWidth > 768) {
    var pdItemHeight = $(".product-item .left").height();
    $(".merchandise-grid .promo-banner").css("height", pdItemHeight);
  }
});

function callApi(url) {
  document.getElementById("loading-animation").style.display = "grid";
  // loading = true;
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      let html_div = document.createElement("div");
      html_div.innerHTML = data;

      let html_dom = html_div.querySelector("#ProductGridContainer").innerHTML;
      document.querySelector("#ProductGridContainer").innerHTML = html_dom;
      // console.log("from callAPi", url);
      $(".variant_img_color_custom").on("click", function () {
        // console.log("click from Modal");
        var newImg = $(this).attr("data-href");
        var $productContentWrapper = $(this).closest(
          ".product-content-wrapper"
        );
        $productContentWrapper.find(".mpt-image").attr({
          srcset: newImg,
          src: newImg,
        });
      });

      // Collection-redesign Start

      $(".new-template .filter-icon > span").click(function () {
        $(".new-template .sidebar-overlay").removeClass("hide");
      });

      $(
        ".new-template .sidebar-overlay, .new-template span.filter-cross_icon"
      ).click(function () {
        $(".new-template .sidebar-overlay").addClass("hide");
      });

      $(".view-count .pd_view").text(
        $(".new-template .products-on-page .product-item").length
      );

      $(".read_more-btn").unbind("click");
      $(".read_more-btn").click(function (e) {
        if ($(e.target).text() == "READ MORE") {
          $(".collection_redesign .desc-container").addClass("show_more");
          $(e.target).text("READ LESS");
        } else {
          $(".collection_redesign .desc-container").removeClass("show_more");
          $(e.target).text("READ MORE");
        }
      });

      // hiding the discover more button based on next pagination URL
      if ($(".pagination a.next").attr("href") === "") {
        $(".fastor_ajax_load_button").hide();
      } else {
        $(".fastor_ajax_load_button").show();
      }

      let minWidth = 991;
      if (
        !(window.innerWidth < minWidth || screen.width < minWidth) &&
        $.fn.slick !== "undefined"
      ) {
        // Slick Slider function here
        $(".collection-redesign .color_variant.color-slide").slick({
          dots: false,
          infinite: false,
          arrows: false,
          slidesToShow: 11,
          slidesToScroll: 1,
          centerPadding: "10px",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 8,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }

      // Collection-redesign end

      // Re-run the last separator adjustments
      updateLastSeparator();
      // update url without refreshing the page
      const scripts = html_div.querySelectorAll(
        'script[data-exec-on-load="true"]'
      );
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        if (script.src) {
          newScript.src = script.src;
          document.body.appendChild(newScript);
        } else {
          newScript.textContent = script.textContent;
          document.body.appendChild(newScript);
          document.body.removeChild(newScript);
        }
      });

      history.replaceState(null, null, url);
    })
    .catch((error) => console.error("Error:", error))
    .finally(() => {
      // loading = false;
      document.getElementById("loading-animation").style.display = "none";
      var filterEvent = new Event("filterAction");
      document.dispatchEvent(filterEvent);
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const filterGroups = document.querySelectorAll(".filter-group");
  let anyFilterActive = false;

  filterGroups.forEach(function (filterGroup, index) {
    const isActive = filterGroup.querySelector("input:checked") !== null;
    if (isActive) {
      anyFilterActive = true;

      filterGroup.open = false; // Open the filter group if any filter is active
    } else if (index !== 0 || anyFilterActive) {
      filterGroup.open = false; // Close other filter groups if the first one is not active or any filter is active
    }
  });

  // If no filter is active, only open the first filter group
  if (!anyFilterActive && filterGroups.length > 0) {
    filterGroups[0].open = true;
    filterGroups[1].open = true;
    filterGroups[5].open = true;
  }
});
